import type { Reroute, Transport } from '@sveltejs/kit';
import { deLocalizeUrl } from '$lib/paraglide/runtime';

/**
 * Reroute hook: maps localized, browser-facing URLs (e.g. `/pt/services`,
 * `/es`) to the canonical, locale-agnostic route (`/services`, `/`) that the
 * file-based router actually defines. Paraglide's middleware still sets the
 * per-request locale based on the original (localized) URL, so the right
 * messages render for each path. The English (base) locale has no prefix.
 *
 * IMPORTANT: This must live in `src/hooks.ts` (universal), not the server-only
 * `src/hooks.server.ts`.
 */
export const reroute: Reroute = (request) => {
	return deLocalizeUrl(request.url).pathname;
};

export const transport: Transport = {};
